export default {
    bartolome_config: {
        url: null,
        centro: null,
        apikey: null
    },
    mewo_config: {
        url: null,
        apikey: null
    },
    activo: true,
    pago: null,
    servicio: null,
    //totemObj : null,
    /** //neoMix | standalone. Ya siempre será standalone, ya que los precios y disponibilidad
     * Neo se actualizan en servidor. En cliente siempre se tiene copia desde el mismo sitio
     */
    modoFuncionamiento: "standalone",
    formaPago: [{
        tipo: ['recoger', 'domicilio'],
        id: 'tarjeta_online',
        img: '../../assets/img/pagoTarjetaOnline.png',
        name: 'finalizar.dialog.stepPago.btn.online.name',
        text: 'finalizar.dialog.stepPago.btn.online.text'
    }, {
        tipo: ['domicilio'],
        id: 'tarjeta_domicilio',
        img: '../../assets/img/pagoTarjetaEntrega.png',
        name: 'finalizar.dialog.stepPago.btn.tarjeta.name',
        text: 'finalizar.dialog.stepPago.btn.tarjeta.text'
    }, {
        tipo: ['domicilio'],
        id: 'efectivo',
        img: '../../assets/img/pagoMetalico.png',
        name: 'finalizar.dialog.stepPago.btn.efectivo.name',
        text: 'finalizar.dialog.stepPago.btn.efectivo.text'
    }, {
        tipo: ['recoger'],
        id: 'local',
        img: '../../assets/img/pagoMetalico.png',
        name: 'finalizar.dialog.stepPago.btn.local.name',
        text: 'finalizar.dialog.stepPago.btn.local.text'
    }
        // {
        //     id : 'paypal',
        //     img : '../../assets/img/pagoTarjetaOnline.png',
        //     name: 'finalizar.dialog.stepPago.btn.paypal.name',
        //     text : 'finalizar.dialog.stepPago.btn.paypal.text'
        // }
    ]
}